module.exports = __webpack_public_path__ + "static/media/arrow-left-red.0bdcf97e.svg";